import { defineStore } from "pinia"
import { SlideShowService } from "@/store/services/slideShow.service.js"
import { storeToRefs } from "pinia"

export const slideShowStore = defineStore("slideShow", {
  state: () => {
    return {
      slideShow: "",
    }
  },
  getters: {
    getSlideShows: (state) => state.slideShow,
  },
  actions: {
    getSlideShowsAction() {
      if (this.slideShow != "") return this.slideShow
      EventSys.$emit("slideShow_loading")
      SlideShowService.list().then(({ data }) => {
        EventSys.$emit("slideShow_loaded")
        this.slideShow = data
      })
    },
  },
})
